import Garden from '@/components/Growth/Garden';

const Completed = () => <Garden />;

export default Completed;
